/* eslint-disable no-undef */
import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import { menuItems, sidebarMenuItems } from './MenuItem'
import { CookiesHelper, goToHomePage, showSnackBar, showLoader } from '../../helpers/Utils'
import ConfirmationModal from '../common/ConfirmationModal'
import { useTranslation } from 'react-i18next'
import { USER_RESPONSE_KEY, USER_ROLES } from 'src/constants/siteConstant'

function Navigation ({ authActions, authState, dashboardState }) {
  const [selectedMenu, setSelectedMenu] = useState('')
  const { t } = useTranslation(['dashboard'])
  const [logoutModalOpen, setLogoutModalOpen] = useState(false)
  const [openMenus, setOpenMenus] = useState({})
  const [selectedLanguage, setSelectedLanguage] = useState('German')
  const userRole = JSON.parse(window.localStorage.getItem(USER_RESPONSE_KEY) || '{}')?.role

  useEffect(() => {
    const defaultLanguage = CookiesHelper.getItem('defaultLanguage')
    if (defaultLanguage) {
      setSelectedLanguage(defaultLanguage === 'en' ? 'English' : 'German')
    }
  }, [])

  const handleMenuClick = (menu) => setSelectedMenu(menu)
  const handleGoToHomePage = () => (window.location.href = '/')

  const onLanguageChange = (lang, langName) => {
    CookiesHelper.setItem('defaultLanguage', lang, 604800, '/')
    setSelectedLanguage(langName)
    window.location.reload()
  }

  const handleLogout = () => {
    showLoader()
    showSnackBar(open, { displayMsg: authState?.authResponse })
    authActions.tryLogout()
    goToHomePage()
  }

  const isMenuActive = (subItems) => subItems?.some((subItem) => '/' + subItem?.url === window.location.pathname)

  const toggleNestedMenu = (menu) => {
    setOpenMenus((prevState) => ({ ...prevState, [menu]: !prevState[menu] }))
  }

  return (
    <>
      <nav className='flex flex-col min-h-screen border-gray-200 w-[250px] px-4 py-3' id='navbarVertical'>
        <div className='flex items-center justify-between mb-4'>
          <button className='text-gray-500 lg:hidden' type='button'>
            <span className='text-xl'>☰</span>
          </button>
        </div>
        <div className='mb-6 cursor-pointer' onClick={handleGoToHomePage}>
          <img src='https://d3brnpc5nhvc9v.cloudfront.net/static-assets-helloparts/logos/helloparts-Logo-x.png' alt='logo' className='h-8' />
        </div>
        <ul className='space-y-2 pl-0'>
          {sidebarMenuItems?.map((menu, index) => {
            const menuConfig = menuItems[menu]
            const isActive = isMenuActive(menuConfig?.subItems)
            const hideMenu = (menuConfig.sysAdminCheck && userRole !== USER_ROLES.SYSTEM_ADMIN)
            return (
              <React.Fragment key={menuConfig?.name + index}>
                {!hideMenu &&
                  <li>
                    {menuConfig?.subItems?.length > 0
                      ? (
                        <>
                          <div className={`flex items-center justify-between px-3 py-2 rounded cursor-pointer hover:bg-gray-100 ${isActive ? 'bg-gray-100 font-semibold' : ''}`} onClick={() => toggleNestedMenu(menu)}>
                            <span className='flex items-center gap-2'>{menuConfig.icon} {menu === 'language' ? selectedLanguage : ''}</span>
                            <i className={`bi bi-chevron-${openMenus[menu] ? 'up' : 'down'}`} />
                          </div>
                          {openMenus[menu] && (
                            <ul className='pl-6 list-none space-y-1'>
                              {menuConfig?.subItems?.map((subItem, subIndex) => (
                                <li key={subItem.name + subIndex}>
                                  <Link
                                    className={`block px-3 py-1 rounded hover:bg-gray-100 text-[#16192c] ${'/' + subItem.url === window.location.pathname ? 'text-[#6926D9] font-medium' : ''}`}
                                    to={subItem?.url}
                                    onClick={(e) => {
                                      e.preventDefault()
                                      const langCode = subItem.url.split('/').pop()
                                      onLanguageChange(langCode, subItem.name)
                                    }}
                                  >
                                    {subItem?.name}
                                  </Link>
                                </li>
                              ))}
                            </ul>
                          )}
                        </>
                        )
                      : (
                        <Link
                          key={menuConfig?.name + index}
                          to={`/${menuConfig?.url}`}
                          className={`flex items-center px-3 py-2 gap-2 rounded hover:bg-gray-100 text-[#16192c] ${'/' + menuConfig?.url === window.location.pathname ? 'bg-gray-100 text-[#6926D9] font-semibold' : ''}`}
                          onClick={() => handleMenuClick(menu)}
                        >
                          {menuConfig?.icon} {menuConfig?.name}
                        </Link>
                        )}
                  </li>}
              </React.Fragment>
            )
          })}
        </ul>

        <ul className='space-y-2 mt-auto pl-0'>
          <li>
            <div
              className={`flex items-center px-3 py-2 gap-2 rounded cursor-default text-[#16192c] ${selectedMenu === 'accounts' || window.location.pathname === '/accounts' ? 'bg-gray-100 font-semibold' : ''}`}
            >
              <i className='bi bi-person-square' /> {dashboardState?.dashboardData?.first_name || ''}
            </div>
          </li>
          <li onClick={() => setLogoutModalOpen(true)}>
            <span className='flex items-center px-3 py-2 gap-2 rounded cursor-pointer hover:bg-gray-100'>
              <i className='bi bi-box-arrow-left' /> {t('logout')}
            </span>
          </li>
        </ul>
      </nav>

      {logoutModalOpen &&
        (
          <ConfirmationModal
            show={logoutModalOpen}
            onHide={() => setLogoutModalOpen(false)}
            onConfirm={handleLogout}
            message={t('logoutText')}
            title={t('logout')}
            confirmBtnTxt={t('yes')}
            cancelBtnTxt={t('no')}
          />)}
    </>
  )
}

export default Navigation
